import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../images/aizo-plan.png';
import SidebarLinkGroup from './SidebarLinkGroup';

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const { pathname } = location;

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  const [sidebarExpanded, setSidebarExpanded] = useState(storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true');

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (!sidebarOpen || sidebar.current.contains(target) || trigger.current.contains(target)) return;
      setSidebarOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  useEffect(() => {
    localStorage.setItem('sidebar-expanded', sidebarExpanded);
    if (sidebarExpanded) {
      document.querySelector('body').classList.add('sidebar-expanded');
    } else {
      document.querySelector('body').classList.remove('sidebar-expanded');
    }
  }, [sidebarExpanded]);

  return (
    <div>
      {/* Sidebar backdrop (mobile only) */}
      <div
        className={`fixed inset-0 bg-slate-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        aria-hidden="true"
      ></div>

      {/* Sidebar */}
      <div
        id="sidebar"
        ref={sidebar}
        className={`flex flex-col absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 lg:w-20 lg:sidebar-expanded:!w-64 2xl:!w-64 shrink-0 bg-slate-800 p-4 transition-all duration-200 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-64'
          }`}
      >
        {/* Sidebar header */}
        <div className="flex justify-center  mb-10 pr-3 sm:px-2">
          {/* Close button */}
          <button
            ref={trigger}
            className="lg:hidden text-slate-500 hover:text-slate-400"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-controls="sidebar"
            aria-expanded={sidebarOpen}
          >
            <span className="sr-only">Close sidebar</span>
            <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
            </svg>
          </button>
          {/* Logo */}
          <NavLink end to="/" className="block">
            <img className="  p-1 w-full" src={logo} width="100" height="32" alt="logo" />
          </NavLink>
        </div>

        {/* Links */}
        <div className="space-y-8">
          {/* Pages group */}
          <div>
            <h3 className="text-xs uppercase text-slate-500 font-semibold pl-3">
              <span className="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden text-center w-6" aria-hidden="true">
                •••
              </span>
              <span className="lg:hidden lg:sidebar-expanded:block 2xl:block">Pages</span>
            </h3>
            <ul className="mt-3">
              {/* Dashboard 
               <SidebarLinkGroup activecondition={pathname === '/' || pathname.includes('dashboard')}>
                {(handleClick, open) => (
                  <NavLink
                    to="/dashboard"
                    className={`block text-slate-200 hover:text-white truncate transition duration-150 ${(pathname === '/' || pathname.includes('dashboard')) && 'hover:text-slate-200'}`}
                    onClick={(e) => {
                      sidebarExpanded ? handleClick() : setSidebarExpanded(true);
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        {/* Dashboard Icon *
                        <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                          <path
                            className={`fill-current text-slate-400 ${(pathname === '/' || pathname.includes('dashboard')) && '!text-indigo-500'}`}
                            d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z"
                          />
                          <path
                            className={`fill-current text-slate-600 ${(pathname === '/' || pathname.includes('dashboard')) && 'text-indigo-600'}`}
                            d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z"
                          />
                          <path
                            className={`fill-current text-slate-400 ${(pathname === '/' || pathname.includes('dashboard')) && 'text-indigo-200'}`}
                            d="M12 15c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L6 6l4.714 3.301A2.973 2.973 0 0112 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z"
                          />
                        </svg>
                        <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                          Dashboard
                        </span>
                      </div>
                    </div>
                  </NavLink>
                )}
              </SidebarLinkGroup> */}

              {/* User Management */}
              <SidebarLinkGroup activecondition={pathname.includes('users')}>
                {(handleClick, open) => (
                  <NavLink
                    to="/users"
                    className={`block text-slate-200 hover:text-white truncate transition duration-150 ${pathname.includes('users') && 'hover:text-slate-200'}`}
                    onClick={(e) => {
                      sidebarExpanded ? handleClick() : setSidebarExpanded(true);
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        {/* User Icon */}
                        <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                          <path
                            className={`fill-current text-slate-600 ${pathname.includes('users') && 'text-indigo-500'}`}
                            d="M18.974 8H22a2 2 0 012 2v6h-2v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5h-2v-6a2 2 0 012-2h.974zM20 7a2 2 0 11-.001-3.999A2 2 0 0120 7zM2.974 8H6a2 2 0 012 2v6H6v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5H0v-6a2 2 0 012-2h.974zM4 7a2 2 0 11-.001-3.999A2 2 0 014 7z"
                          />
                          <path
                            className={`fill-current text-slate-400 ${pathname.includes('users') && 'text-indigo-300'}`}
                            d="M12 6a3 3 0 110-6 3 3 0 010 6zm2 18h-4a1 1 0 01-1-1v-6H6v-6a3 3 0 013-3h6a3 3 0 013 3v6h-3v6a1 1 0 01-1 1z"
                          />
                        </svg>
                        <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                          User Management
                        </span>
                      </div>
                    </div>
                  </NavLink>
                )}
              </SidebarLinkGroup>

              {/* User Management */}
              <SidebarLinkGroup activecondition={pathname.includes('organization')}>
                {(handleClick, open) => (
                  <NavLink
                    to="/organization"
                    className={`block text-slate-200 hover:text-white truncate transition duration-150 ${pathname.includes('organization') && 'hover:text-slate-200'}`}
                    onClick={(e) => {
                      sidebarExpanded ? handleClick() : setSidebarExpanded(true);
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        {/* User Icon */}
                        <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                          <path
                            className={`fill-current text-slate-400 ${pathname.includes('organization') && 'text-indigo-300'}`}
                            d="M13 6.068a6.035 6.035 0 0 1 4.932 4.933H24c-.486-5.846-5.154-10.515-11-11v6.067Z"
                          />
                          <path
                            className={`fill-current text-slate-700 ${pathname.includes('organization') && '!text-indigo-500'}`}
                            d="M18.007 13c-.474 2.833-2.919 5-5.864 5a5.888 5.888 0 0 1-3.694-1.304L4 20.731C6.131 22.752 8.992 24 12.143 24c6.232 0 11.35-4.851 11.857-11h-5.993Z"
                          />
                          <path
                            className={`fill-current text-slate-600 ${pathname.includes('organization') && 'text-indigo-600'}`}
                            d="M6.939 15.007A5.861 5.861 0 0 1 6 11.829c0-2.937 2.167-5.376 5-5.85V0C4.85.507 0 5.614 0 11.83c0 2.695.922 5.174 2.456 7.17l4.483-3.993Z"
                          />
                        </svg>
                        <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                          Organization
                        </span>
                      </div>
                    </div>
                  </NavLink>
                )}
              </SidebarLinkGroup>

              {/*industry*/}
              <SidebarLinkGroup activecondition={pathname.includes('industry')}>
                {(handleClick, open) => (
                  <NavLink
                    to="/industry"
                    className={`block text-slate-200 hover:text-white truncate transition duration-150 ${pathname.includes('industry') && 'hover:text-slate-200'}`}
                    onClick={(e) => {
                      sidebarExpanded ? handleClick() : setSidebarExpanded(true);
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        {/* Industry Icon */}
                        <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                          <path
                            className={`fill-current text-slate-600 ${pathname.includes('departement') && 'text-indigo-500'}`}
                            d="M2 21h20V11l-6 4V9l-6 4V3H2v18z"
                          />
                          <path
                            className={`fill-current text-slate-400 ${pathname.includes('departement') && 'text-indigo-300'}`}
                            d="M4 19h2v-6H4v6zm4 0h2v-4H8v4zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2z"
                          />
                          
                        </svg>

                        <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                          Industry
                        </span>
                      </div>
                    </div>
                  </NavLink>
                )}
              </SidebarLinkGroup>


              {/* Customer Journey */}
              <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('customerJourney') && 'bg-slate-900'}`}>
                <NavLink
                  end
                  to="/customerJourney"
                  className={`block text-slate-200 hover:text-white truncate transition duration-150 ${pathname.includes('customerJourney') && 'hover:text-slate-200'
                    }`}
                >
                  <div className="flex items-center">
                    <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                      <path
                        className={`fill-current text-slate-600 ${pathname.includes('customerJourney') && 'text-indigo-500'}`}
                        d="M20 7a.75.75 0 01-.75-.75 1.5 1.5 0 00-1.5-1.5.75.75 0 110-1.5 1.5 1.5 0 001.5-1.5.75.75 0 111.5 0 1.5 1.5 0 001.5 1.5.75.75 0 110 1.5 1.5 1.5 0 00-1.5 1.5A.75.75 0 0120 7zM4 23a.75.75 0 01-.75-.75 1.5 1.5 0 00-1.5-1.5.75.75 0 110-1.5 1.5 1.5 0 001.5-1.5.75.75 0 111.5 0 1.5 1.5 0 001.5 1.5.75.75 0 110 1.5 1.5 1.5 0 00-1.5 1.5A.75.75 0 014 23z"
                      />
                      <path
                        className={`fill-current text-slate-400 ${pathname.includes('customerJourney') && 'text-indigo-300'}`}
                        d="M17 23a1 1 0 01-1-1 4 4 0 00-4-4 1 1 0 010-2 4 4 0 004-4 1 1 0 012 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-1 1zM7 13a1 1 0 01-1-1 4 4 0 00-4-4 1 1 0 110-2 4 4 0 004-4 1 1 0 112 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-1 1z"
                      />
                    </svg>
                    <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                      Customer Journey
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('operationJourney') && 'bg-slate-900'}`}>
                <NavLink
                  end
                  to="/operationJourney"
                  className={`block text-slate-200 hover:text-white truncate transition duration-150 ${pathname.includes('operationJourney') && 'hover:text-slate-200'
                    }`}
                >
                  <div className="flex items-center">
                    <svg
                      className="shrink-0 h-6 w-6"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className={`fill-current text-slate-600 ${pathname.includes('operationJourney') && 'text-indigo-500'}`}
                        d="M12 2a1 1 0 011 1v2.07a8.001 8.001 0 015.92 5.92H21a1 1 0 110 2h-2.08a8.001 8.001 0 01-5.92 5.92V21a1 1 0 11-2 0v-2.08a8.001 8.001 0 01-5.92-5.92H3a1 1 0 110-2h2.08A8.001 8.001 0 0111 5.07V3a1 1 0 011-1z"
                      />
                      <path
                        className={`fill-current text-slate-400 ${pathname.includes('operationJourney') && 'text-indigo-300'}`}
                        d="M8 12a4 4 0 118 0 4 4 0 01-8 0zm4-6a6 6 0 100 12 6 6 0 000-12z"
                      />
                    </svg>

                    <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                      Operation Journey
                    </span>
                  </div>
                </NavLink>
              </li>
            <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${(pathname.includes('support-dashboard') || pathname.includes('tickets')) && 'bg-slate-900'}`}>
              <NavLink
                end
                to="/support-dashboard"
                className={`block text-slate-200 hover:text-white truncate transition duration-150 ${
                  (pathname.includes('support-dashboard') || pathname.includes('tickets')) && 'hover:text-slate-200'
                }`}
              >
                <div className="flex items-center">
                  <svg
                    className="shrink-0 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className={`stroke-current text-slate-600 ${(pathname.includes('support-dashboard') || pathname.includes('tickets')) && 'text-indigo-500'}`}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 6h8M8 10h8M8 14h5m-9 6h10a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>

                  <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                    Tickets
                  </span>
                </div>
              </NavLink>
            </li>
            <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('capability-maps') && 'bg-slate-900'}`}>
            <NavLink
              end
              to="/capability-maps"
              className={`block text-slate-200 hover:text-white truncate transition duration-150 ${
                pathname.includes('capability-maps') && 'hover:text-slate-200'
              }`}
            >
              <div className="flex items-center">
                
                {/* Capability Maps Icon (Layers / Structure) */}
                <svg
                  className="shrink-0 h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className={`stroke-current text-slate-600 ${pathname.includes('capability-maps') && 'text-indigo-500'}`}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6l8-4 8 4-8 4-8-4zm0 6l8 4 8-4m-16 6l8 4 8-4"
                  />
                </svg>
          
                <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                  Capability Maps
                </span>
              </div>
            </NavLink>
          </li>

          <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('help-center') && 'bg-slate-900'}`}>
            <NavLink
              end
              to="/help-center"
              className={`block text-slate-200 hover:text-white truncate transition duration-150 ${
                pathname.includes('help-center') && 'hover:text-slate-200'
              }`}
            >
              <div className="flex items-center">
                
                {/* Capability Maps Icon (Layers / Structure) */}
                <svg
                  className="shrink-0 h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className={`stroke-current text-slate-600 ${pathname.includes('help-center') && 'text-indigo-500'}`}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6l8-4 8 4-8 4-8-4zm0 6l8 4 8-4m-16 6l8 4 8-4"
                  />
                </svg>
          
                <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                  Help Center
                </span>
              </div>
            </NavLink>
          </li>
             
            </ul>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Sidebar;
